module.exports = __webpack_public_path__ + "img/B2.55ceca29.png";